// extracted by mini-css-extract-plugin
export default {"modalWrapper":"OpenMultiLanguage_modalWrapper__VxflW","modalContentWrapper":"OpenMultiLanguage_modalContentWrapper__F7MO+"};